import React, { useState, useRef } from 'react';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import DemoWizardItem from '../../../Domain/DemoWizardItem';
import DemoWizardWindowDescription from './DemoWizardWindowDescription';
import DemoSinglePageWindowDescription from './DemoSinglePageWindowDescription';

function WizardDemoComponent() {
  // Holds the windowDescription class of the currently open wizard (null = closed).
  const [openDescription, setOpenDescription] = useState(null);
  const [lastSaved, setLastSaved] = useState(null);
  // The wizard's success path invokes clickOnSave via ErrorMessage.SetSuccess(msg, okFn)
  // with NO arguments, so we track the latest edited item ourselves.
  const latestEditedItem = useRef(null);

  return (
    <div>
      <div className='dsg-row'>
        <button
          type='button'
          className='btn primary'
          onClick={() => setOpenDescription(() => DemoWizardWindowDescription)}
        >
          <i className='fa-solid fa-plus' /> Open multi-step wizard
        </button>
        <button
          type='button'
          className='btn'
          onClick={() => setOpenDescription(() => DemoSinglePageWindowDescription)}
        >
          <i className='fa-solid fa-pen' /> Open single-page edit panel (compact modal)
        </button>
      </div>
      {lastSaved ? (
        <p style={{ fontSize: 13, color: 'var(--ink-2)' }}>
          Last "saved" item (in-memory): {JSON.stringify(lastSaved)}
        </p>
      ) : null}
      {openDescription ? (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={new DemoWizardItem()}
          clickOnCancel={() => setOpenDescription(null)}
          clickOnSave={(savedItem) => {
            setLastSaved(savedItem || latestEditedItem.current);
            setOpenDescription(null);
          }}
          onChangeEditedItem={(edited) => {
            latestEditedItem.current = edited;
          }}
          windowDescription={openDescription}
          errorCode='DSG301'
        />
      ) : null}
    </div>
  );
}

export const wizardDemo = {
  id: 'edit-wizard',
  title: 'Edit wizard (GeneralEditWizzard)',
  category: 'Overlays & Editing',
  importPath: 'Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma',
  notes: [
    'Driven by a static windowDescription class: itemType (factory), serviceFunction (returns a Promise), pagesInGeneralEditWizzard (pages → fields).',
    'This demo’s serviceFunction resolves {} in-memory — nothing reaches the backend.',
    'Wizard serviceFunctions must RETURN the backend call (not await-and-return-true), or a backend error reads as a false green success.',
    'Field types come from InputTypesEnum; validityChecker returns an error string or "" per field.',
    'There is no separate "simple edit panel" component: a windowDescription with a SINGLE page and ≤6 visible fields automatically renders as the compact centered modal (see SetTimesheetUserWindowDescription for a real example).',
    'Select fields take inline options via `selectvalues` (array or function of the edited item); add a { value: "", label: "-- Select --" } placeholder or the first option looks selected while the value stays empty.',
    'Wizard item classes live in src/Domain/<Name>.ts, not co-located in the WindowDescription.',
  ],
  snippet:
    "<GeneralEditWizzardBase\n  crudType={CrudTypesEnum.Create}\n  editedItem={new MyItem()}\n  clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}\n  clickOnSave={this.refresh}\n  windowDescription={EditMyItemWindowDescription}\n  errorCode={'XX123'}\n/>",
  render: WizardDemoComponent,
};
